// -----------------------------------------------------------------------
// <copyright file="ecs.api.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { IAppState } from '../../../web-legacy/models/reduxState';
import { ECS } from '../../models/constants/getHelpConstants';
import { appContext } from '../../models/getHelp/appContext';
import { EcsConfigurationResponse } from '../../models/getHelp/ecsConfigurationResponse';
import { ExperienceMetaData } from '../../models/getHelp/experienceConfigurations';
import { httpUtils } from './httpUtils';
// import { logEcsApiException } from '../utils/logHelper';

/**
 * Service that calls SMC Backend Web Api.
 * @class EcsService
 */
export class EcsService {
  /**
   * Get ECS flighting configuration
   * @param {string[]} productIds The product IDs for the user's licenses
   * @returns {Promise<EcsConfigurationResponse>} The ECS configuration response.
   */
  public async getEcsConfiguration(productIds: string[]): Promise<EcsConfigurationResponse> {
    const locale: string = appContext.locale;
    const localeSplit: string[] = locale?.split('-');
    // Todo: Brook - check if we should get ECS configs from SMC backend
    let url: string =
      appContext.environment.ecsConfigUrl +
      `config/v1/${ECS.ClientApp}/${appContext.appver}` +
      `?agents=${ECS.TeamName}` +
      `&clientId=${appContext.deviceId}` +
      `&locale=${locale}` +
      `&appVersion=${appContext.appver}` +
      `&OS=${appContext.systemInfo?.OS}` +
      `&MajorOSVersion=${appContext.systemInfo?.MajorOSVersion}`;

    if (!!localeSplit && localeSplit.length > 1) {
      url += `&country=${localeSplit[1]}`;
    }

    if (!!productIds && productIds.length > 0) {
      for (const productId of productIds) {
        url += `&productId=${productId}`;
      }
    } else {
      url += '&productId=';
    }

    try {
      const apiResponse: EcsConfigurationResponse = await httpUtils.get<EcsConfigurationResponse>(url);

      return apiResponse;
    } catch (error) {
      // Log error and return null
      if (error.status !== 429) {
        // await logEcsApiException(error);
      }
      return null;
    }
  }

  public ecsIsEnabled(getState: () => IAppState): boolean {
    const appState: IAppState = getState();
    const getHelpConfig: ExperienceMetaData = appState.GlobalState.getHelpConfig;
    const selectedFlights: string[] = getHelpConfig ? getHelpConfig?.FeatureFlightSelectedList : [];
    return (
      selectedFlights?.includes(ECS.EnabledFlag) || selectedFlights?.some(str => str.endsWith('_' + ECS.EnabledFlag))
    );
  }
}

export const ecsService = new EcsService();
